<template>
  <div class="" v-loading="quickLoading">
    <div class="head_css marTop15" v-show="!quickItem.length">
      <div class="track_detail color26 ">
        {{$t('page.not_find_data')}}
      </div>
    </div>
    <div v-for="(item,index) in quickItem" :key="index">
      <div class="head_css marTop15" v-show="(item.trackingStatus === stateValue) || (item.searchResultCode === stateValue) || !stateValue">
        <div class="quick_query_head pointer" @click="showChange(index)">
          <div class="flex flexWrap">
            <div v-show="item.trackingStatus" class="state_tag marRight20" :class="classObject(item.trackingStatus)">
              <i class="iconfont size16 IconB" :class="iconFilter(item.trackingStatus)"></i>
              <span>{{searchResultFilter(item.trackingStatus)}}</span>
            </div>
            <div class="infoTit tracking_no marRight30">{{$t('page.tracking_no')}}：{{item.trackingNo}}</div>
            <div style="line-height:40px;" v-show="item.searchResultCode !== 'Completed'" :class="colorFliter(item.searchResultCode)" class="marRight100">{{searchResultFilter('', item.searchResultCode)}}</div>
            <div class="quick_query_head_line marRight100">{{filterCarriers(item.carrierCode)}}</div>
            <!-- <div class="flex marRight100 quick_query_head_line">
              <div>新加坡</div>
              <div><i class="iconfont color26 icon-lianjiefu size18 marLeft10 marRight10"></i></div>
              <div>赛尔维亚</div>
            </div> -->

            <div v-show="item.searchResultCode === 'Failure' && !item.trackingStatus" style="height:20px;line-height:20px;margin-top:10px;" class="colorR marRight100">{{$t('page.please_track__latter')}}</div>
            <div class="quick_query_head_line last_track"
                 v-if="item.logisticsTrackingSections.length && item.latestTrackingEvent" :title="utils.timeFormat(item.latestTrackingEvent.trackingTime.dateTime, 'yyyy-MM-dd hh:mm:ss') +'--'+ item.latestTrackingEvent.description">
              <!--            {{utils.timeFormat(latestTrackTime(item), 'yyyy-MM-dd hh:mm:ss') + latestTrack(item)}}-->
              {{utils.timeFormat(item.latestTrackingEvent.trackingTime.dateTime, 'yyyy-MM-dd hh:mm:ss') +'--'+ item.latestTrackingEvent.description}}
              <!--            item.latestTrackingEvent.trackingTime.dateTime-->
              <!--            item.latestTrackingEvent.description-->
            </div>
            <!--          <div class="quick_query_head_line" v-else>{{$t('page.Not_Found')}}</div>-->
          </div>
          <div class="flex quick_query_head_line marLeft15 color26">
            <div class="pointer flex">
              <span v-show="item.spreadShow" class="whiteSpace">{{$t('page.hide_list')}}</span>
              <span v-show="!item.spreadShow" class="whiteSpace">{{$t('page.show_list')}}</span>
              <span class="workbench_icon">
              <i class="el-icon-arrow-up" :class="{'transform180': !item.spreadShow, 'transform0': item.spreadShow}"></i>
            </span>
            </div>
          </div>
        </div>
        <el-collapse-transition>
          <div v-show="item.spreadShow">
            <quick-detail v-show="item.searchResultCode === 'Completed' || item.searchResultCode === 'PartialFailure'"
                          :detail="item"
                          :index="index">
            </quick-detail>
            <div class="track_detail" v-show="item.searchResultCode === 'Searching'">
              <div class="no_detail">
                <span class="color26">{{$t('page.being_in_query')}}<i class="size14 color26 el-icon-loading"></i></span>
              </div>
            </div>
            <div class="track_detail" v-show="item.searchResultCode === 'Failure'">
              <div class="no_detail">
                <span class="colorR">{{$t('page.failed_query')}}</span>
                <el-button size="small" type="primary" @click="shipperOpen(true, item)">{{$t('page.carrier')}}</el-button>
              </div>
            </div>
            <div class="track_detail" v-show="item.searchResultCode === 'FailMatchCarrier'">
              <div class="no_detail">
                <span class="colorR">{{$t('page.cannot_found_carrier_please_choose_carrier')}}</span>
                <el-button size="small" type="primary" @click="shipperOpen(true, item)">{{$t('page.carrier')}}</el-button>
              </div>
            </div>
            <div class="track_detail" v-show="item.searchResultCode === 'MultiCarriers' || item.trackingStatus == 'NotFound'">

              <div class="colorW">
                {{$t('page.maybe_these_carrier')}}
                <el-button size="small" type="primary" @click="shipperOpen(true, item)">{{$t('page.carrier')}}</el-button>
              </div>
              <div class="flex marTop20" style="flex-wrap: wrap;">
                <div class="post_box flex marTop10" @click="chooseShipper(item, t)" v-for="(t, i) in item.possibleCarriers" :key="i">
                  <div class="post_img">
                    <img :src="carrieImg(t)" alt="" style="border: 1px solid #efefef;">
                  </div>
                  <div>
                    {{filterCarriers(t)}}
                  </div>
                </div>
              </div>

              <!-- <div class="no_detail marTop10">
                <span class="colorW">您也可以自由选择运输商，请选择</span>
                 <el-button size="small" type="primary" @click="shipperOpen(true, item)">运输商</el-button>
              </div> -->
            </div>
          </div>

        </el-collapse-transition>
      </div>
    </div>

    <choose-shipper @close="shipperOpen" v-if="shipperShow"></choose-shipper>
  </div>
</template>

<script>
  import {quickSearch} from '@/api/getSearch.js'
  import quickDetail from './quickDetail.vue'
  import chooseShipper from './chooseShipper.vue'
  import LocalStorage from '@/common/localStorage.js'

  export default {
    components: {
      quickDetail,
      chooseShipper
    },
    props: {
      stateValue: '',
      nums:''
    },
    data() {
      return {
        quickItem: [],
        quickItemAll: [],
        noFinish: [],
        carrierCode: '',
        shipperShow: false,
        oneData: {},
        quickLoading: false
      }
    },
    created() {
      // console.log(LocalStorage.get('carriers'))
      console.log(this.$route.path)
      if (this.$route.path === '/trackingResults' && LocalStorage.get('searchList')) {
        this.search(LocalStorage.get('searchList'))
      }
    },
    methods: {
      latestTrackTime(item) {//取最新轨迹最后一个值的时间
        let Section = item.logisticsTrackingSections
        let latestTrackAll = item.logisticsTrackingSections[Section.length - 1].logisticsTracking.items
        let latestTrac = latestTrackAll.length > 0 ? latestTrackAll[latestTrackAll.length - 1].trackingTime.dateTime : ''
        return latestTrac
      },
      latestTrack(item) {//取最新轨迹最后一个值
        let Section = item.logisticsTrackingSections
        let latestTrackAll = item.logisticsTrackingSections[Section.length - 1].logisticsTracking.items
        let latestTrac = latestTrackAll.length > 0 ? ('-' + latestTrackAll[latestTrackAll.length - 1].description) : this.$t('page.Not_Found')
        return latestTrac
      },
      filterCarriers(code) {
        let vm = this
        let text = ''
        LocalStorage.get('carriers').map(function (item) {
          if (code === item.code) {
            if (vm.$i18n.locale === 'zh-cn') {
              text = item.zhName
            }
            if (vm.$i18n.locale === 'en') {
              text = item.enName
            }
          }
        })
        return text
      },
      carrieImg(code) {
        let url = ''
        LocalStorage.get('carriers').map(function (item) {
          if (code === item.code) {
            url = item.logoPictureUrl
          }
        })
        return url
      },
      showChange(index, value) {
        if (value) {
          this.$set(this.quickItem[index], 'spreadShow', value)

        } else {
          this.$set(this.quickItem[index], 'spreadShow', !this.quickItem[index].spreadShow)
        }
      },
      search(list) {
        this.quickLoading = true
        this.noFinish = []
        this.carrierCode = list.items[0].carrierCode
        let vm = this
        quickSearch(list)
          .then((res) => {
            vm.quickItem = res.trackingResults
            // vm.$emit('getNum', vm.quickItem)
            res.trackingResults.map(function (item) {
              if (item.searchResultCode === 'Searching') {
                vm.noFinish.push(item)
              }
            })
            setTimeout(function () {
              if (vm.noFinish.length) {
                vm.polling()
              }
            }, 3000)
            setTimeout(function () {
              vm.showChange(0, true)
            }, 1000)
            this.quickLoading = false
          })
          .catch((err) => {
            this.quickLoading = false
          })
        localStorage.removeItem('shippers-choose')
        // localStorage.removeItem('searchList')
      },
      polling(carrierCode) {
        let vm = this
        let params = {
          items: []
        }
        for (let i = 0; i < vm.noFinish.length; i++) {
          params.items.push({
            trackingNo: vm.noFinish[i].trackingNo,
            carrierCode: carrierCode ? carrierCode : vm.carrierCode
          })
        }
        quickSearch(params)
          .then((res) => {
            let outlist = []
            res.trackingResults.map(function (item, o) {
              // item.spreadShow = true
              if (item.searchResultCode !== 'Searching') {
                vm.quickItem.map(function (t, i) {
                  if (t.trackingNo === item.trackingNo) {
                    vm.$set(vm.quickItem, i, item) // 查询状态不等于Searching的数据放入快速查询运单列表quickItem
                    // vm.$emit('getNum', vm.quickItem)
                  }
                })
                vm.noFinish.splice(o, 1, '无效') // 这次轮询中完成查询的运单数组中已经Ok的（不是Searching的）替换成字符串‘无效’
              }
            })
            // 这次轮询中完成查询的运单数组中已经Ok的（不是Searching的）替换成字符串‘无效’   且删除‘无效’（最后删除）
            vm.noFinish = vm.noFinish.filter(it => {
              return it !== '无效'
            })
            setTimeout(function () {
              if (vm.noFinish.length) {
                vm.polling()
              }
            }, 3000)
            // setTimeout(function () {
            //   vm.showChange(0, true)
            // }, 1000)
          })
      },
      searchResultFilter(state, code) {
        if (state) {
          switch (state) {
            case 'ArrivedDelivery':
              return this.$t('page.Pick_Up')
              break
            case 'Delivering':
              return this.$t('page.Delivering')
              break
            case 'Delivered':
              return this.$t('page.Delivered')
              break
            case 'DeliveryFailure':
              return this.$t('page.Undelivered')
              break
            case 'Return':
              return this.$t('page.Return')
              break
            case 'Exception':
              return this.$t('page.Exception')
              break
            case 'InTransit':
              return this.$t('page.In_Transit')
              break
            case 'NotFound':
              return this.$t('page.Not_Found')
              break
            case 'InfoReceived':
              return this.$t('page.Info_Received')
              break
          }
        } else {
          switch (code) {
            case 'Searching':
              return this.$t('page.in_query')
              break
            // case 'Completed':
            //   return this.$t('page.query_successful')
            //   break
            case 'Failure':
              return this.$t('page.not_find_tracking')
              break
            // case 'PartialFailure':
            //   return this.$t('page.query_successful')
            //   break
            case 'MultiCarriers':
              return this.$t('page.please_choose_carrier')
              break
            case 'FailMatchCarrier':
              return this.$t('page.please_choose_carrier')
              break
          }
        }
      },
      iconFilter(state) {
        switch (state) {
          case 'ArrivedDelivery':
            return 'icondaodakequ'
            break
          case 'Delivering':
            return 'iconpaisongtuzhong'
            break
          case 'Delivered':
            return 'iconchenggongpaisong'
            break
          case 'DeliveryFailure':
            return 'icontoudishibai'
            break
          case 'Return':
            return 'iconbaoguotuihui'
            break
          case 'Exception':
            return 'iconkenengyichang'
            break
          case 'InTransit':
            return 'iconyunshutuzhong'
            break
          case 'NotFound':
            return 'iconchaxunshibai'
            break
          case 'InfoReceived':
            return 'iconyubaofahuo'
            break
        }
      },
      colorFliter(code) {
        switch (code) {
          case 'Pending':
            return 'color26'
            break
          case 'Searching':
            return 'color26'
            break
          case 'Failure':
            return 'colorF20'
            break
          case 'Success':
            return 'colorG2'
            break
          case 'Suspend':
            return 'color26'
            break
          case 'UnsupportedSearch':
            return 'colorF20'
            break
          case 'NotProvideTracking':
            return 'colorF20'
            break
        }
      },
      classObject(state, code) {
        if (state) {
          switch (state) {
            case 'ArrivedDelivery':
              return 'back0AB'
              break
            case 'Delivering':
              return 'backF5C'
              break
            case 'Delivered':
              return 'back39D'
              break
            case 'DeliveryFailure':
              return 'backF20'
              break
            case 'Return':
              return 'backFF3'
              break
            case 'Exception':
              return 'backFE6'
              break
            case 'InTransit':
              return 'backF58'
              break
            case 'NotFound':
              return 'back289'
              break
            case 'InfoReceived':
              return 'back266'
              break
          }
        } else {
          switch (code) {
            case 'Searching':
              return 'back26'
              break
            case 'Completed':
              return 'backG2'
              break
            case 'Failure':
              return 'backFE'
              break
            case 'PartialFailure':
              return 'backG2'
              break
            case 'MultiCarriers':
              return 'backW'
              break
            case 'FailMatchCarrier':
              return 'backW'
              break
          }
        }
      },
      chooseShipper(item, carrierCode) {
        let vm = this
        let params = {
          items: [
            {
              trackingNo: item.trackingNo,
              carrierCode: carrierCode
            }
          ]
        }
        quickSearch(params)
          .then((res) => {
            if (res.trackingResults[0].searchResultCode !== 'Searching') {
              vm.quickItem.map(function (item, index) {
                if (item.trackingNo === res.trackingResults[0].trackingNo) {
                  // item = res.trackingResults[0]
                  vm.$set(vm.quickItem, index, res.trackingResults[0])
                  // vm.$emit('getNum', vm.quickItem)
                }
              })
            } else {
              vm.chooseShipperPolling(params)
              vm.quickItem.map(function (item, index) {
                if (item.trackingNo === res.trackingResults[0].trackingNo) {
                  // item = res.trackingResults[0]
                  vm.$set(vm.quickItem, index, res.trackingResults[0])
                  // vm.$emit('getNum', vm.quickItem)
                }
              })
            }
          })
        localStorage.removeItem('shippers-choose')
        localStorage.removeItem('searchList')
      },
      chooseShipperPolling(params) {
        let vm = this
        setTimeout(function () {
          quickSearch(params)
            .then((res) => {
              if (res.trackingResults[0].searchResultCode !== 'Searching') {
                vm.quickItem.map(function (item, index) {
                  if (item.trackingNo === res.trackingResults[0].trackingNo) {
                    // item = res.trackingResults[0]
                    vm.$set(vm.quickItem, index, res.trackingResults[0])
                    // vm.$emit('getNum', vm.quickItem)
                  }
                })
              } else {
                vm.chooseShipperPolling(params)
                vm.quickItem.map(function (item, index) {
                  if (item.trackingNo === res.trackingResults[0].trackingNo) {
                    item = res.trackingResults[0]
                    vm.$set(vm.quickItem, index, res.trackingResults[0])
                    // vm.$emit('getNum', vm.quickItem)
                  }
                })
              }
            })
        }, 3000)
      },
      shipperOpen(value, item) {
        this.shipperShow = value
        if (value) {
          this.oneData = item
        }
        if (!value) {
          this.chooseShipper(this.oneData, LocalStorage.get('shippers-choose').code)
        }
      }
    }
  }
</script>

<style scoped>
  .quick_query {
    height: calc(100vh - 150px);
    /*overflow: auto;*/
  }

  .quick_query_head {
    display: flex;
    justify-content: space-between;
  }
  .workbench_icon {
    width: 16px;
    height: 40px;
    line-height: 40px;
    text-align: right;
  }

  .quick_query_head_line {
    line-height: 40px;
  }

  .state_tag {
    padding: 0 10px;
    height: 20px;
    line-height: 20px;
    color: #ffffff;
    margin: 10px 0;
    border-radius: 4px;
    text-align: center;
  }

  .last_track {
    width: 625px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .track_detail {
    padding: 15px 40px;
    background-color: #ffffff;
    /* display: flex;
    justify-content: space-between; */
  }

  .no_detail {
    height: 32px;
    line-height: 32px;
  }

  .post_box {
    height: 40px;
    margin-right: 50px;
    /* display: flex; */
    cursor: pointer;
    text-align: center;
    line-height: 40px;
    border-radius: 5px;
  }

  .post_img {
    width: 40px;
    height: 40px;
    margin-right: 10px;
  }

  .post_img img {
    width: 40px;
    height: 40px;
  }

  .post_box:hover {
    background-color: #f7f7f7;
  }
  .minheight{
    min-height: 400px;
  }
</style>
<style scoped>
  @media only screen and (min-width: 400px) and (max-width: 768px) {
      .tracking_no {
        margin-right: 0;
      }
    .state_tag .iconfont{
      display: none;
    }
  }
  @media only screen and (min-width: 768px) and (max-width: 1366px) {

  }

</style>



// WEBPACK FOOTER //
// src/components/new/quickQuery.vue